const ufeApi = require('services/api/ufeApi');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Country+List+API

function getCountryList() {
    const url = '/api/util/countries';

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data.countries));
}

module.exports = getCountryList;
